import {
  POST_REGISTER_LOADING_CUSTOMER,
  POST_REGISTER_DONE_CUSTOMER,
  POST_REGISTER_ERROR_CUSTOMER,
  POST_REGISTER_LOADING_MERCHANT,
  POST_REGISTER_DONE_MERCHANT,
  POST_REGISTER_ERROR_MERCHANT
} from './actions'

export default {
  [POST_REGISTER_LOADING_CUSTOMER] (state) {
    state.isLoading = true
  },

  [POST_REGISTER_DONE_CUSTOMER] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [POST_REGISTER_ERROR_CUSTOMER] (state, error) {
    state.error = error
    state.isLoading = false
  },

  [POST_REGISTER_LOADING_MERCHANT] (state) {
    state.isLoading = true
  },

  [POST_REGISTER_DONE_MERCHANT] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [POST_REGISTER_ERROR_MERCHANT] (state, error) {
    state.error = error
    state.isLoading = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/register/mutations.js